<template>
  <div
    :class="{ line: index == jShow, tenderItem: true }"
    @mouseenter="jMover(index)"
    @mouseleave="jShow = -1"
    @click="goNewDetail(item.id, item)"
  >
    <div>
      <div class="head">
      <div class="title">
        <span
          class="dataSourceTag"
          v-if="
            item.dataSources && item.dataSources !== 2 && item.businessType != 4
          "
          >{{ item.dataSourcesName }}</span
        >
        <span
          class="proName"
          :title="item.name"
          v-if="item.label !== '需求预告'"
          >{{ item.name }}</span
        >
        <span class="proName" :title="item.projectName" v-else>{{
          item.projectName
        }}</span>
      </div>
      <div 
        class="title_yusuan ellipsis" 
        v-if="item.businessType == 3">
        <span style="color: #E1251B;margin-left:-5px;"
          >【需求预算】
        </span>
        <span 
          style="color: #ff6600;margin-left:-10px;" 
          v-if="item.typeName && item.type != 20"
        >
          【{{item.typeName}}】
        </span>
        <span 
          style="color: #B79255;;margin-left:-5px;" 
          v-if="item.inquiryMethods && item.inquiryMethods.length"
        >
           <span v-for="(e,i) in item.inquiryMethods" :key="i" style="margin-left:-5px;">【{{e}}】</span>
        </span>
        <span 
          style="color: #ff6600;margin-left:20px;" 
          v-if="item.money"
        >
          <span style="color: #666;">概算金额：</span> 
          {{item.money}}元
        </span>
      </div>
      <div class="titleInfo" v-else>
        <!-- 3.9.2  新增 招标形式 -->
        <span style="color: #ff6600" class="widmax" v-if="item.label != '需求预告' && item.typeName!=null"
          >【{{ item.typeName }}】</span
        >
        <span style="color: #0286df" v-if="item.biddingMethodName"
          >【{{ item.biddingMethodName }}】</span
        >
        <span style="color: #ff6600" v-if="item.label == '需求预告'"
          >【{{ item.moduleType }}】</span
        >
        <span style="color: #0286df" v-if="item.rotation && item.state !== 9"
          >【第{{ item.rotation }}轮】</span
        >
        <span style="color: #78c06e" v-if="item.verticalTypeName"
          >【{{ item.verticalTypeName }}】</span
        >
        <span style="color: #78c06e" v-if="item.qualificationWayName"
          >【{{ item.qualificationWayName }}】</span
        >
        <span class="moneySpan" v-if="item.label != '需求预告'">
          预算金额:<span style="color: #ff6600">{{
            getMoney(item.money)
          }}</span>
        </span>
      </div>
      <!-- businessType 1 招标 2 竞价 -->
      <template v-if="item.businessType == 2">
        <img class="i-status" v-if="item.state === 2" src="@/assets/jjz.png" />
        <img
          class="i-status"
          v-else-if="item.state === 5"
          src="@/assets/tpz.png"
        />
        <img class="i-status" v-else src="@/assets/jjyjs.png" />
      </template>
      <template v-else-if="item.businessType == 3">
        <img class="i-status" src="@/assets/xunjiazhong.png" />
      </template>
      <template v-else>
        <img
          class="i-status"
          v-if="item.state === 1"
          src="../../../assets/jjzb.png"
        />
        <img
          class="i-status"
          v-if="item.state === 2 || item.state === 6"
          src="../../../assets/zzzb.png"
        />
        <img
          class="i-status"
          v-if="item.state === 3"
          src="../../../assets/jbpb.png"
        />
        <img
          class="i-status"
          v-if="item.state === 4"
          src="../../../assets/zbdb.png"
        />
        <img
          class="i-status"
          v-if="item.state === 8"
          src="../../../assets/zbyg.png"
        />
        <img
          class="i-status"
          v-if="item.state === 9"
          src="../../../assets/zbbm.png"
        />
      </template>
      </div>
    </div>
    <template  v-if="item.businessType == 3">
      <div class="body" style="height: 152px">
        <BidItem :itemObj="item"></BidItem>
      </div>
    </template>
    <template v-else>
      <div
        class="body"
        v-if="item.goodsList && item.goodsList.length"
        :style="{ 'height': item.goodsHeader && item.goodsHeader.length  ? 'auto' : '0px' }"
        >
        <BidItem :itemObj="item"></BidItem>
      </div>
    </template>

    <listCommonContent :currentInfo="item" v-if="item.businessType != 3"/>
    <div class="notice_bot" v-if="item.businessType == 3">
      <div class="notice_bot_meg" style="margin-bottom:5px;">
          <p class="key">发布时间：</p>
          <p class="val">{{Number(item.releaseTime) | formaHoures}}</p>
      </div>
      <div class="notice_bot_meg" style="margin-bottom:5px;">
          <p class="key">发布单位：</p>
          <p class="val1">{{item.type == 4? item.agentComName :item.comName}}</p>
      </div>
      <div class="notice_bot_meg">
          <img src="../../../assets/location.png" alt="" class="img">
          <p class="key">地址：</p>
          <p class="val1">{{item.fullAddress}}</p>
      </div>
    </div>
    <jPop
      class="jPop-box"
      v-if="index == jShow"
      :item="item"
      :detailData="detailData"
      :type="typeNum"
      :jIndex="index"
      :dialog="dialogShow"
      @inByLetDialogClick="inByLetDialogClick"
      @go="goNewDetail(item.id, item)"
    ></jPop>
  </div>
</template>
<script>
export default {
  components: {
    BidItem: () => import('@/views/hotTender/components/BidItem'),
    jPop: () => import('@/components/zhaocai/jPop'),
    listCommonContent: () => import('./listCommonContent.vue')
  },
  data() {
    return {
      jShow: -1,
      dialogShow: true,
      detailData:{},
    };
  },
  props: {
    item: {
      type: Object,
    },
    index: {
      type: Number,
    },
  },
  computed: {
    itemData: function () {
      let arr = [];
      this.item.goodsList &&
        this.item.goodsList.map((list, index) => {
          let objData = {};
          list &&
            list.map((itt, i) => {
              objData[itt.name] = itt.value;
            });
          arr.push(objData);
        });
      return arr;
    },
    typeNum: function () {
      if (this.item.businessType === 2) {
        return 0;
      } else if (this.item.businessType === 3) {
        return 5;
      } else {
        return -1;
      }
    },
  },
  methods: {
    jMover(i) {
      this.jShow = i;
    },
    // 函询
    inByLetDialogClick(e, s, obj) {
      if (s == 3) {
        this.$emit("deByLetDialogClick", e, s, obj);
      } else {
        this.$emit("inByLetDialogClick", e, s, obj);
      }
    },
    goNewDetail(no, obj = {}) {
      if (obj.dataSources === 2) {
        let url = `${process.env.VUE_APP_ZHAOCAI}/tenderDetails?id=${obj.id}`;
        window.open(url);
      } else {
        if (obj.businessType === 2) {
          window.open(process.env.VUE_APP_ZHAOCAI+"/CompeteBiddingDetail?no=" + obj.id + "&typeName=" + obj.typeName);
        } else if (obj.businessType === 3) {
          // let url = `/demandEsDetail?id=${obj.id}&type=${obj.type}`;
          // window.open(url);
          if (obj.type && obj.type == 4) {
            window.open(process.env.VUE_APP_ZHAOCAI+"/demandNoticeDetail" + "?id=" + obj.id);
          } else if (obj.type && obj.type == 3) {
            window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?id=" + obj.id);
          } else if (obj.type && obj.type == 2) {
            window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + obj.id + "&&type=10");
          } else if (obj.type && obj.type == 19) {
            window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + obj.id + "&&type=9");
          } else if (obj.type && obj.type == 20) {
            window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + obj.id + "&&type=8");
          } else if (obj.type) {
            window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + obj.id);
          }
        } else if (obj.businessType === 4) {
          window.open(`${process.env.VUE_APP_ZHAOCAI}/hotTenderAdvanceLaborDetail?no=${obj.id}`);
        } else {
          if (this.$route.path === "/direct-jb") {
            window.open(`${process.env.VUE_APP_ZHAOCAI}/CompeteBiddingDetail?no=${no}`);
          } else {
            if (obj.state === 8) {
              window.open(process.env.VUE_APP_ZHAOCAI+"/biddingDetail?id=" + obj.id);
            } else {
              window.open(`${process.env.VUE_APP_ZHAOCAI}/hotTenderMachineLaborDetail?no=${no}`);
            }
          }
        }
      }
    },
    // 商机数据的关注
    getMoney(val) {
      if (val >= 10000) {
        return (val / 10000).toString().match(/^\d+(?:\.\d{0,2})?/) + "万元";
      } else {
        return val ? `${val}元` : "按清单组价";
      }
    },
    getBackground(status) {
      let str = "";
      switch (status) {
        case 1:
          str = "#F7AB01";
          break;
        case 2:
          str = "#0286DF";
          break;
        case 3:
          str = "#78C06E";
          break;
        case 4:
          str = "#969696";
          break;
        case 5:
          str = "#969696";
          break;
        case 6:
          str = "#0286DF";
          break;
        case 8:
          str = "#409ee9";
          break;
        case 9:
          str = "#78C06E";
          break;
        case 10:
          str = "#F7AB01";
          break;
        default:
          str = "#969696";
          break;
      }
      return str;
    },
  },
  filters: {
    dealStatus(status) {
      // 招标状态
      let str = "";
      switch (status) {
        case 1:
          str = "待招标";
          break;
        case 2:
          str = "招标中";
          break;
        case 3:
          str = "评标中";
          break;
        case 4:
          str = "招标结束";
          break;
        case 5:
          str = "废标";
          break;
        case 6:
          str = "招标中";
          break;
        case 7:
          str = "流标";
          break;
        case 8:
          str = "待报名";
          break;
        case 9:
          str = "报名中";
          break;
        case 10:
          str = "资格审查中";
          break;
        default:
          break;
      }
      return str;
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.tenderItem {
  box-sizing: border-box;
  float: left;
  cursor: pointer;
  border: 1px solid #e4e7ed;
  margin-right: 20px;
  margin-bottom: 20px;
  width: 569px;
  height: 335px;
  position: relative;
  &:nth-child(even) {
    margin-right: 0;
  }
  &:hover {
    border-bottom: none;
    transform: translateY(-19px);
    transition: all 0.2s ease-in-out;
    .footer {
      height: 72px;
    }
  }
  .head {
    height: 68px;
    width: 100%;
    background: #f5f7fa;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    padding: 10px;
    border-bottom: 1px solid #e4e7ed;
    .title {
      box-sizing: border-box;
      width: 100%;
      height: 30px;
      margin-left: 8px;
      font-size: 16px;
      color: #333;
      font-weight: normal;
      display: flex;
      align-items: center;
      .proName{
        display: inline-block;
        width: calc(100% - 100px);
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
    }
    .dataSourceTag {
      background: linear-gradient(90deg, #f17658 0%, #df361b 100%);
      color: #fff;
      font-size: 12px;
      width: 48px;
      height: 20px;
      padding: 3px;
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .titleInfo {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: start;
      .moneySpan {
        color: #666666;
        margin-left: 5px;
      }
      .widmax{
        max-width: 210px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .title_yusuan {
      // 需求预算样式 
      width: 520px;
      font-size: 14px;
      margin-left: 8px;
      color: #ff6600;

      .moneySpan {
        color: #666666;
        margin-left: 5px;
      }
    }
    .i-status {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .body {
    box-sizing: border-box;
    margin: 0px 10px;
    max-height: 166px;
    border-bottom: 1px dashed #e4e7ed;
    overflow-x: hidden;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .notice_bot {
      padding: 20px 10px 10px 10px;
      .notice_bot_meg {
          font-size: 14px;
          display: flex;
          margin-bottom: 10px;
          :last-child{
              margin-bottom: none;
          }
          .img{
              width: 14px;
              height: 14px;
              margin-top: 3px;
          }
          .key {
              color: #666;
          }
          .val {
              line-height: 21px;
              color: #969696;
          }
          .val1 {
              line-height: 21px;
              color: #333;
              width: 425px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
          }
          img {
              width: 14px;
              height: 17px;
              margin-right: 5px;
          }
      }
  }
  /deep/.body .el-table td {
    padding: 9px 0;
    border: 0;
  }
}

/deep/.body .el-table th {
  padding: 7px 0;
  border: 0;
}
/deep/.el-table:before {
  height: 0;
}
/deep/.el-table .cell {
  color: #333333 !important;
}
/deep/.el-table .el-table__row .cell {
  color: #666666 !important;
}
/deep/ .body .el-table td {	 
    padding: 7px 0 !important;	 
}
.line {
  border: 1px solid #b79255 !important;
}
.ellipsis {
  // 文本强制不换行
  white-space: nowrap;
  // 溢出显示省略号
  text-overflow: ellipsis;
  // 溢出的部分隐藏
  overflow: hidden;
}
.footer {
  padding: 0px 10px;
  box-sizing: border-box;
  padding-top: 20px;
}
.footer-item {
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
  > span {
    color: #666666;
  }
}
.dashedLine {
  width: 100%;
  border-top: 1px dashed #E4E7ED;
  margin-bottom: 16px;
}
.jPop-box {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  transform: translateY(100%);
}
</style>
